import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleType: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Type',
        defaultMessage: 'Vehicle Type',
    },
    vehicleTypePlaceholder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Type --',
        defaultMessage: '-- Choose Vehicle Type --',
    },
    additionalDetails: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Additional Details',
        defaultMessage: 'Additional Details',
    },
    vehicleUsage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Usage',
        defaultMessage: 'Vehicle Usage',
    },
    vehicleCondition: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Condition',
        defaultMessage: 'Vehicle Condition',
    },
    vehicleMileage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Mileage/Commute',
        defaultMessage: 'Vehicle Mileage/Commute',
    },
    safetyInformation: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Safety Information',
        defaultMessage: 'Safety Information',
    },
    additionalInformation: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Additional Vehicle Information',
        defaultMessage: 'Additional Vehicle Information',
    },
    isTowingTrailer_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Towing a Trailer',
        defaultMessage: 'Vehicle Towing a Trailer'
    },
    funeralDirectorVehType_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Funeral Director Vehicle Type',
        defaultMessage: 'Funeral Director Vehicle Type'
    },
    numOfSeats_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.No of Seats',
        defaultMessage: 'No of Seats'
    },
    isTrailerSupplCarryCapcity_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Does the trailer supplement the carrying capacity of the automobile?',
        defaultMessage: 'Does the trailer supplement the carrying capacity of the automobile?'
    },
    trailerType_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Trailer Supplement',
        defaultMessage: 'Trailer Supplement'
    },
    bodyStyle_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Body Style',
        defaultMessage: 'Body Style'
    },
    // isSlowMovingVehicle_EY: {
    //     id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Slow Moving Vehicle',
    //     defaultMessage: 'Slow Moving Vehicle'
    // },
    bodyType: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Trailer Type',
        defaultMessage: 'Trailer Type'
    },
    engineType_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Engine Type',
        defaultMessage: 'Engine Type'
    },
    pistonDisplacement_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Engine Displacement (cc)',
        defaultMessage: 'Engine Displacement (cc)'
    },
    engineCylinders: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Engine Cylinders',
        defaultMessage: 'Engine Cylinders'
    },
    engineCylindersPlaceHolder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Engine Cylinders --',
        defaultMessage: '-- Choose Engine Cylinders --'
    },
    garagedAt: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Garaged At',
        defaultMessage: 'Garaged At'
    },
    underAgeDrivers_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Under Age Driver(s)',
        defaultMessage: 'Under Age Driver(s)'
    },
    neworUsed: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.New or Used',
        defaultMessage: 'New or Used',
    },
    neworUsedPlaceholder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose New or Used --',
        defaultMessage: '-- Choose New or Used --',
    },
    purchasePrice: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Purchase Price',
        defaultMessage: 'Purchase Price',
    },
    listPrice: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.List Price',
        defaultMessage: 'List Price',
    },
    purchaseDate: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Purchase Date',
        defaultMessage: 'Purchase Date',
    },
    ownershipType: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Ownership Type',
        defaultMessage: 'Ownership Type',
    },
    ownershipTypePlaceholder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Ownership Type --',
        defaultMessage: '-- Choose Ownership Type --',
    },
    grossWeight_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Gross Vehicle Weight (kgs)',
        defaultMessage: 'Gross Vehicle Weight (kgs)'
    },
    odomoeterReading: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Odomoeter (kms)',
        defaultMessage: 'Odomoeter (kms)',
    },
    appraisalDate_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Appraisal Date',
        defaultMessage: 'Appraisal Date'
    },
    appraisalValue_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Appraisal Amount',
        defaultMessage: 'Appraisal Amount'
    },
    primaryUse: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Primary Use',
        defaultMessage: 'Primary Use'
    },
    primaryUsePlaceholder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Primary Use --',
        defaultMessage: '-- Choose Primary Use --'
    },
    businessPercentage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Business Percentage',
        defaultMessage: 'Business Percentage'
    },    
    personalPercentage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Personal Percentage',
        defaultMessage: 'Personal Percentage'
    },
    annualMileage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Annual Kilometers',
        defaultMessage: 'Annual Kilometers'
    },
    commutingMiles: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Daily Commute Kilometres (one way)',
        defaultMessage: 'Daily Commute Kilometres (one way)'
    },
    winterTires: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Winter Tires',
        defaultMessage: 'Winter Tires'
    },
    winterTireInstDate: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Winter Tire Installation Date',
        defaultMessage: 'Winter Tire Installation Date',
    },
    afterMarketTheftDevice: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.After Market Theft System',
        defaultMessage: 'After Market Theft System'
    },
    specialFarmUse: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Special Farm Use',
        defaultMessage: 'Special Farm Use',
    },
    commercialUse: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Commercial Use',
        defaultMessage: 'Commercial Use',
    },
    usExposure: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.US Exposure',
        defaultMessage: 'US Exposure',
    },
    usExposurePercent: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.US Exposure Percent',
        defaultMessage: 'US Exposure Percent'
    },
    vehicleFuelType: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Fuel Type',
        defaultMessage: 'Vehicle Fuel Type',
    },
    vehicleFuelTypePlaceholder: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Fuel Type --',
        defaultMessage: '-- Choose Vehicle Fuel Type --',
    },
    vehicleCustomized: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Customized',
        defaultMessage: 'Vehicle Customized',
    },
    customizedAmount: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Customized Amount',
        defaultMessage: 'Customized Amount',
    },
    delivery_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Delivery',
        defaultMessage: 'Delivery'
    },
    useOfVehicle_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Use of Vehicle',
        defaultMessage: 'Use of Vehicle'
    },
    typeOfUse_EY:{
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Type of Use',
        defaultMessage: 'Type of Use'
    },
    distanceRadiusHorseFilter:{
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Radius of Operations',
        defaultMessage: 'Radius of Operations'
    },
    distanceRadiusNonHorseFilter: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Radius of Operations',
        defaultMessage: 'Radius of Operations'
    },
    destinationCities_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Destination Cities',
        defaultMessage: 'Destination Cities'
    },
    seasonalDelivery_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Seasonal Delivery',
        defaultMessage: 'Seasonal Delivery'
    },
    radiusNumOfKms_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of Kms',
        defaultMessage: 'Number of Kms'
    },
    radiusNumOfTrips_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of Trips',
        defaultMessage: 'Number of Trips'
    },
    describe_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Describe',
        defaultMessage: 'Describe'
    },
    haulNonOwnedTrailers_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Haul Non-Owned Trailers',
        defaultMessage: 'Haul Non-Owned Trailers'
    },
    description_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Non-Owned Trailer Description',
        defaultMessage: 'Non-Owned Trailer Description'
    },
    cvorNumber_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.CVOR Number',
        defaultMessage: 'CVOR Number'
    },
    covrRating_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.CVOR Rating',
        defaultMessage: 'CVOR Rating'
    },
    covrViolationRate_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.CVOR Violation Rate (%)',
        defaultMessage: 'CVOR Violation Rate (%)'
    },
    covrViolationDate_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.CVOR Report Date',
        defaultMessage: 'CVOR Report Date'
    },
    covrReOrderDate_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.CVOR Re-Order Date',
        defaultMessage: 'CVOR Re-Order Date'
    },
    towingVehicle_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Tows this Trailer',
        defaultMessage: 'Vehicle Tows this Trailer'
    },
    towingVehicleClassofUse_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Towing Vehicle - Class of Use',
        defaultMessage: 'Towing Vehicle - Class of Use'
    },
    multiVehicleDiscount_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Apply Multi Vehicle Discount',
        defaultMessage: 'Apply Multi Vehicle Discount'
    },
    vehicleRateBy: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Rate By',
        defaultMessage: 'Rate By'
    },
    vehicleRateByGroup: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Group',
        defaultMessage: 'Group'
    },
    vehicleRateByValue: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Value',
        defaultMessage: 'Value'
    },
    vehicleViccCode: {
        id: 'quoteandbind.pa.directives.templates.ba-edit-vehicle.VICC Code',
        defaultMessage: 'VICC Code',
    },
    vehicleValue: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Value',
        defaultMessage: 'Value',
    },
    atvWheels_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of Wheels',
        defaultMessage: 'Number of Wheels'
    },
    rateEffectiveDate: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Rate Effective Date',
        defaultMessage: 'Rate Effective Date',
    },
    vehiclebodyWeightCode: {
        id: 'quoteandbind.pa.directives.templates.ba-edit-vehicle.Body Weight Code',
        defaultMessage: 'Body Weight Code',
    },
    vehicleTrailerDescription: {
        id: 'quoteandbind.pa.directives.templates.ba-edit-vehicle.Trailer Description',
        defaultMessage: 'Description',
    },
    isOperatedOutsideProvince_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Operated Outside of Province/Country',
        defaultMessage: 'Operated Outside of Province/Country'
    },    
    outOfProvince_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Out of Province (KMs)',
        defaultMessage: 'Out of Province (KMs)'
    },
    outOfProvinceTime_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Out of Country (Days)',
        defaultMessage: 'Out of Country (Days)'
    },
    isSlowMovingVehicle_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Offroad Motorcycle',
        defaultMessage: 'Offroad Motorcycle'
    },
    vehicleAppraisal: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Appraisal',
        defaultMessage: 'Vehicle Appraisal'
    },
    customisationType_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Customization Type',
        defaultMessage: 'Customization Type'
    },
    customizationDescribe_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Description',
        defaultMessage: 'Description'
    },
    classOfUse: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Class of Use',
        defaultMessage: 'Class of Use'
    },
    commercialTrailerError: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Commercial-Trailer needs a "Vehicle that tows this trailer" to be added. Please add a supporting vehicle to proceed.',
        defaultMessage: 'Commercial-Trailer needs a "Vehicle that tows this trailer" to be added. Please add a supporting vehicle to proceed.'
    },
    touring:{
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Touring ?',
        defaultMessage: 'Touring ?'
    },
    moped:{
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Moped ?',
        defaultMessage: 'Moped ?'
    },
    numberOfTripsPerYear: {
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of Trips/Year",
        defaultMessage: "Number of Trips/Year"
    },
    numberOfLocations:{
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of locations(per Day)",
        defaultMessage: "Number of locations(per Day)"
    },
    garagedOutsideUSA_EY:{
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Garaged outside United States for 6 months?",
        defaultMessage: "Garaged outside United States for 6 months?"
    },
    trailmasterDiscount_EY:{
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Trailmaster Discount",
        defaultMessage: "Trailmaster Discount"
    },
    genNowDiscount_EY:{
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Gennow! Discount",
        defaultMessage: "Gennow! Discount"
    },
    commuteDaysPerWeek_EY:{
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Commute Days per week",
        defaultMessage: "Commute Days per week"
    },
    isTrailorUsedForPersonalUse_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Trailor Used for Personal Use',
        defaultMessage: 'Trailor Used for Personal Use'
    },
    usedForCarpool_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Is any automobile used for car pooling?',
        defaultMessage: 'Is any automobile used for car pooling?',
    },
    unrepairedDamage: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Unrepaired Damage?',
        defaultMessage: 'Unrepaired Damage?',
    },
    haulLivestock_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Haul Livestock',
        defaultMessage: 'Haul Livestock'
    },
    telematicsDiscount: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Telematics Discount',
        defaultMessage: 'Telematics Discount'
    },
    enrolledInTelematicsInd: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Enroll For Telematics Discount',
        defaultMessage: 'Enroll For Telematics Discount'
    },
    isElectricVehicle_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Electric Vehicle',
        defaultMessage: 'Electric Vehicle'
    },
    engineDisplacement_EY: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Engine Displacement (hp)',
        defaultMessage: 'Engine Displacement (hp)'
    },
    kmsOverNormalRadius: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Kms over normal radius',
        defaultMessage: 'Kms over normal radius'
    },
    numberOfTripsBeyondNormalRadius: {
        id: "quoteandbind.pa.directives.templates.pa-edit-vehicle.Number of Trips beyond Normal Radius Per Year",
        defaultMessage: "Number of Trips beyond Normal Radius Per Year"
    },
});
